/**
 * Mermaid diagramok renderelése. A könyvtár csak akkor töltődik le, ha a
 * dokumentumban tényleg van ```mermaid blokk.
 */
let mermaidPromise: Promise<typeof import('mermaid').default> | null = null;

async function loadMermaid(dark: boolean) {
  if (!mermaidPromise) {
    mermaidPromise = import('mermaid').then((m) => {
      m.default.initialize({
        startOnLoad: false,
        securityLevel: 'strict',
        theme: dark ? 'dark' : 'default',
        fontFamily: 'inherit',
      });
      return m.default;
    });
  }
  return mermaidPromise;
}

/** A megadott konténerben minden .mermaid-block elemet diagrammá alakít. */
export async function renderMermaid(root: ParentNode, dark: boolean): Promise<void> {
  const blocks = Array.from(root.querySelectorAll<HTMLElement>('pre.mermaid-block'));
  if (!blocks.length) return;

  const mermaid = await loadMermaid(dark);
  await Promise.all(
    blocks.map(async (block, i) => {
      const src = block.textContent ?? '';
      const wrapper = document.createElement('figure');
      wrapper.className = 'mermaid-figure';
      try {
        const { svg } = await mermaid.render(`mermaid-${Date.now()}-${i}`, src);
        wrapper.innerHTML = svg;
      } catch (err) {
        wrapper.className = 'mermaid-figure mermaid-figure--error';
        const pre = document.createElement('pre');
        pre.textContent = `A diagram nem renderelhető:\n${String(err)}\n\n${src}`;
        wrapper.appendChild(pre);
      }
      block.replaceWith(wrapper);
    }),
  );
}
